module.exports = __webpack_public_path__ + "static/media/krabbelgruppe.d436d1fb.jpg";